/*
 * EL CARRITO LATERAL: cerrar al pulsar el velo (22/09/2026) y anadir sin
 * vuelo al carrito desde dentro (05/10/2026).
 *
 * El carrito es el cajon de Horizon (`theme-drawer#cart-drawer`) con el
 * formato de Tamara. En pantallas de 990 px o mas Horizon lo abre con
 * `show()` y no como modal: no hay `::backdrop`, y su propio «clic fuera»
 * esta apagado en ese modo. El velo es el `body::after` de la seccion 54 del
 * CSS, y un clic en un pseudoelemento llega con destino su elemento: el
 * `body`. Asi que se cierra SOLO cuando el destino es el `body` mismo, y no
 * con «cualquier clic fuera del panel», que fue lo primero y fallaba dos
 * veces (revision del 22/09):
 *   - la barra fija de la ficha pulsa por codigo el boton del formulario
 *     DENTRO de su propio clic; el cajon (con algo ya en el carrito) se abria
 *     en ese mismo instante y el clic, al llegar aqui, lo volvia a cerrar:
 *     entraba, salia y volvia a entrar;
 *   - el aviso de cookies de Shopify flota por encima del velo, y contestarlo
 *     cerraba el carrito.
 * Lo que queda por encima del velo con su propio `z-index` no lo cierra.
 *
 * Por delegacion en `document`: `theme dev` y la Section Rendering API
 * sustituyen nodos, y un oyente colgado de ellos muere sin aviso. Y con
 * guarda, por si el script llega dos veces.
 */
(() => {
  if (window.__nnCajon) return;
  window.__nnCajon = true;

  document.addEventListener('click', (ev) => {
    if (ev.target !== document.body) return;
    const cajon = document.getElementById('cart-drawer');
    const dialogo = cajon?.querySelector('dialog');
    if (!dialogo?.open) return;
    if (typeof cajon.close === 'function') cajon.close();
    else dialogo.close();
  });

  /*
   * «Suscribirme» del recordatorio del 5 % en campaña (natnatura-cajon-vip,
   * reunion con Tamara del 08/10/2026): cierra el cajon y abre el pop-up del
   * boletin, que no se abre encima de otro modal. Se espera a que el
   * <dialog> del cajon este cerrado de verdad (en movil Horizon lo cierra
   * con una animacion).
   */
  document.addEventListener('click', (ev) => {
    const boton = ev.target instanceof Element ? ev.target.closest('[data-nn-cajon-vip]') : null;
    if (!boton) return;
    ev.preventDefault();
    const cajon = document.getElementById('cart-drawer');
    const dialogo = cajon?.querySelector('dialog');
    const abrir = () => document.dispatchEvent(new CustomEvent('nn:captacion:abrir', { bubbles: true }));
    if (!dialogo?.open) {
      abrir();
      return;
    }
    if (typeof cajon.close === 'function') cajon.close();
    else dialogo.close();
    const inicio = Date.now();
    // Si la animacion no termina (pestaña en segundo plano), a los 1,5 s se
    // cierra el <dialog> a mano: el pop-up no se abre con otro modal abierto.
    const espera = () => {
      if (!dialogo.open) abrir();
      else if (Date.now() - inicio > 1500) {
        dialogo.close();
        abrir();
      } else setTimeout(espera, 50);
    };
    setTimeout(espera, 50);
  });

  /*
   * Sin «vuelo al carrito» desde el propio carrito (05/10/2026). Con la
   * animacion de anadir activada, Horizon lanza el bote del boton hacia el
   * icono del carrito de la cabecera; desde «Nuestros recomendados» el icono
   * esta debajo del cajon y lo que se veia era un circulo negro cruzando el
   * panel. Ahi la respuesta ya es la linea nueva entrando en la lista.
   *
   * Horizon lee `data-add-to-cart-animation` al pulsar, desde un oyente en
   * captura sobre `document`; este va en captura sobre `window`, que llega
   * antes. Se pone en cada clic porque el repintado del cajon devuelve el
   * atributo del servidor.
   */
  window.addEventListener(
    'click',
    (ev) => {
      const boton = ev.target instanceof Element ? ev.target.closest('#cart-drawer add-to-cart-component') : null;
      if (boton) boton.dataset.addToCartAnimation = 'false';
    },
    { capture: true }
  );
})();
